module.exports = __webpack_public_path__ + "img/speed-data-pop.c4d282a.svg";